import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';

import { asyncConnectMostRead } from 'modules/Common/reducers/morenews';

import MostReadPanel from '../components/MostReadPanel';

@layoutAsyncConnect(
  "MostReadFootball",
  asyncConnectMostRead("/football")
)
export default class MostReadFootball extends Component {
  static propTypes = {
    mostread: PropTypes.array
  };

  render() {
    return <MostReadPanel articles={this.props.mostread} title="Football" />;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/MostReadFootball.js